import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'
import { loadProfilesSequence } from '../profiles/factories'
import { compose, path, pluck } from 'ramda'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'rewardRedemptions'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  loadProfiles,
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Reward redemption saved', type: 'success' }),
  route.toRewardRedemptions,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Reward redemption deleted', type: 'success' }),
  findForList,
]
